"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgStatusError16(_a, svgRef) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "YdsSvgIcon-root ".concat(className !== null && className !== void 0 ? className : ''), width: '1rem', height: '1rem', fill: "currentColor", focusable: "false", "aria-hidden": "true", ref: svgRef }, props),
        React.createElement("path", { fill: "none", d: "M0 0h16v16H0z" }),
        React.createElement("path", { d: "M8.001 15.657a1.985 1.985 0 01-1.414-.586L.93 9.414a2 2 0 010-2.828L6.587.929a2 2 0 012.828 0l5.657 5.657a2 2 0 010 2.828l-5.657 5.658a1.987 1.987 0 01-1.414.585zm-.127-6.723l1.944 1.943a.5.5 0 00.707 0l.353-.353a.5.5 0 000-.707L8.934 7.873l1.945-1.945a.5.5 0 000-.706l-.354-.354a.5.5 0 00-.707 0L7.874 6.813 5.93 4.868a.5.5 0 00-.707 0l-.354.354a.5.5 0 000 .707l1.945 1.945-1.945 1.944a.5.5 0 000 .707l.354.354a.5.5 0 00.707 0l1.944-1.944z" })));
}
var ForwardRef = React.forwardRef(SvgStatusError16);
exports.default = ForwardRef;
